import { COUNTRIES_DATA } from './countries-data.const';
export const DIAL_CODE = COUNTRIES_DATA;

export enum UserKycStatus {
	None = 0,
	Review = 1,
	Rejected = 2,
	Verified = 3,
}

export enum EscrowType {
	None,
	Banking,
	BankCheck,
	ReceiveUSDT,
	ReceiveVPC,
}

export const STEP = [
	{
		title: 'kyc-form.step1.title',
		key: ['FirstName', 'Middle', 'LastName','PhonePersonal','EmailPersonal', 'DateOfBirth', 'Address', 'Country', 'State', 'ZipCode', 'City'],
		items: [],
		hasItemInvalid: false,
	},
	{
		title: 'kyc-form.step2.title',
		key: ['DocumentType', 'IdentityCardFront', 'Selfie', 'UtilityBillType', 'UtilityBillFront' ],
		items: [],
		hasItemInvalid: false,
	},
	{
		title: 'kyc-form.step3.title',
		key: [
			'BusinessName',
			'BusinessType',
			'BusinessWebsite',
			'BusinessAddress',
			'BusinessCity',
			'BusinessState',
			'BusinessZipCode',
			'BusinessCountry',
			'PhoneNumber',
			'Email',
			'BusinessRegistrationType',
			'BusinessRegistrationImage'
		],
		items: [],
		hasItemInvalid: false,
	},
	{
		title: 'location',
		key: ['Longitude', 'Latitude'],
		items: [],
		hasItemInvalid: false,
	},
];

export enum BusinessRegistrationType {
	'License',
    'Certificate of government'
}

export const BUSINNES_TYPE = [
	{ name: "Retail" },
	{ name: "Food & Beverage" },
	{ name: "Health & Wellness" },
	{ name: "Travel & Tourism" },
	{ name: "Technology & IT" },
	{ name: "Education & Training" },
	{ name: "Finance & Insurance" },
	{ name: "Automotive" },
	{ name: "Fashion & Apparel" },
	{ name: "Entertainment & Media" },
	{ name: "Home & Garden" },
	{ name: "Professional Services" },
	{ name: "Real Estate" },
	{ name: "Construction & Manufacturing" },
	{ name: "Sports & Fitness" },
	{ name: "Logistics & Transportation" },
	{ name: "Beauty & Personal Care" },
	{ name: "Art & Design" },
	{ name: "Pet Services" },
  ];
  
export const SERVICE_BUSINESS = [
	{ name: "General Contractors-Residential and Commercial" },
	{ name: "Heating, Plumbing, and Air Conditioning Contractors" },
	{ name: "Electrical Contractors" },
	{ name: "Masonry, Stonework, Tile Setting, Plastering and Insulation Contractors" },
	{ name: "Carpentry Contractors" },
	{ name: "Roofing, Siding, and Sheet Metal Work Contractors" },
	{ name: "Concrete Work Contractors" },
	{ name: "Special Trade Contractors" },
	{ name: "Miscellaneous Publishing and Printing" },
	{ name: "Typesetting, Plate Making and Related Services" },
	{ name: "Specialty Cleaning, Polishing and Sanitation Preparations" },
	{ name: "Affiliated Auto Rental" },
	{ name: "Taxicabs and Limousines" },
	{ name: "Bus Lines" },
	{ name: "Motor Freight Carriers and Trucking-Local and Long Distance, Moving and Storage Companies, and Local Delivery Services" },
	{ name: "Courier Services-Air and Ground, and Freight Forwarders" },
	{ name: "Public Warehousing and Storage-Farm Products, Refrigerated Goods, Household Goods, and Storage" },
	{ name: "Steamship and Cruise Lines" },
	{ name: "Boat Rentals and Leasing" },
	{ name: "Marinas, Marine Service, and Supplies" },
	{ name: "Travel Agencies and Tour Operators" },
	{ name: "Transportation Services" },
	{ name: "Telecommunication Equipment and Phone Sales" },
	{ name: "Telecommunication Services, including Local and Long Distance Calls, Credit Card Calls, Calls Through Use of Magnetic-Stripe-Reading Telephones, and Fax Services" },
	{ name: "Computer Network/Information Services" },
	{ name: "Telegraph Services" },
	{ name: "Wire Transfer Money Orders (WTMOs)" },
	{ name: "Cable, Satellite and Other Pay Television/Radio/Streaming Services" },
	{ name: "Utilities-Electric, Petrol, Water, and Sanitary" },
	{ name: "Motor Vehicle Supplies and New Parts" },
	{ name: "Office and Commercial Furniture" },
	{ name: "Construction Materials" },
	{ name: "Photographic, Photocopy, Microfilm Equipment and Supplies" },
	{ name: "Computers and Computer Peripheral Equipment and Software" },
	{ name: "Commercial Equipment" },
	{ name: "Medical, Dental, Ophthalmic and Hospital Equipment and Supplies" },
	{ name: "Metal Service Centres and Offices" },
	{ name: "Electrical Parts and Equipment" },
	{ name: "Hardware, Equipment and Supplies" },
	{ name: "Plumbing and Heating Equipment and Supplies" },
	{ name: "Industrial Supplies" },
	{ name: "Precious Stones and Metals, Watches and Jewellery" },
	{ name: "Durable Goods" },
	{ name: "Piece Goods, Notions, and Other Dry Goods" },
	{ name: "Men's, Women's, and Children's Uniforms and Commercial Clothing" },
	{ name: "Commercial Footwear" },
	{ name: "Chemicals and Allied Products" },
	{ name: "Paints, Varnishes and Supplies" },
	{ name: "Nondurable Goods" },
	{ name: "Home Supply Warehouse Stores" },
	{ name: "Lumber and Building Materials Stores" },
	{ name: "Glass, Paint, and Wallpaper Stores" },
	{ name: "Hardware Stores" },
	{ name: "Nurseries and Lawn and Garden Supply Stores" },
	{ name: "Marketplaces" },
	{ name: "Mobile Home Dealers" },
	{ name: "Discount Stores" },
	{ name: "Department Stores" },
	{ name: "Variety Stores" },
	{ name: "Miscellaneous General Merchandise" },
	{ name: "Freezer and Locker Meat Provisioners" },
	{ name: "Candy, Nut, and Confectionery Stores" },
	{ name: "Dairy Products Stores" },
	{ name: "Bakeries" },
	{ name: "Miscellaneous Food Stores-Convenience Stores and Specialty Markets" },
	{ name: "Car and Truck Dealers (New and Used) Sales, Service, Repairs, Parts, and Leasing" },
	{ name: "Car and Truck Dealers (Used Only) Sales, Service, Repairs, Parts, and Leasing" },
	{ name: "Automotive Tyre Stores" },
	{ name: "Automotive Parts and Accessories Stores" },
	{ name: "Boat Dealers" },
	{ name: "Electric Vehicle Charging" },
	{ name: "Camper, Recreational and Utility Trailer Dealers" },
	{ name: "Motorcycle Shops and Dealers" },
	{ name: "Motor Homes Dealers" },
	{ name: "Snowmobile Dealers" },
	{ name: "Miscellaneous Automotive, Aircraft, and Farm Equipment Dealers" },
	{ name: "Men's and Boys' Clothing and Accessories Stores" },
	{ name: "Women's Ready-To-Wear Stores" },
	{ name: "Women's Accessory and Specialty Shops" },
	{ name: "Children's and Infants' Wear Stores" },
	{ name: "Family Clothing Stores" },
	{ name: "Sports and Riding Clothing Stores" },
	{ name: "Shoe Stores" },
	{ name: "Men's and Women's Clothing Stores" },
	{ name: "Tailors, Seamstresses, Mending, and Alterations" },
	{ name: "Wig and Toupee Stores" },
	{ name: "Miscellaneous Clothing and Accessory Shops" },
	{ name: "Furniture, Home Furnishings, and Equipment Stores, Except Appliances" },
	{ name: "Floor Covering Stores" },
	{ name: "Drapery, Window Covering, and Upholstery Stores" },
	{ name: "Fireplace, Fireplace Screens and Accessories Stores" },
	{ name: "Miscellaneous Home Furnishing Specialty Stores" },
	{ name: "Household Appliance Stores" },
	{ name: "Electronics Stores" },
	{ name: "Music Stores-Musical Instruments, Pianos, and Sheet Music" },
	{ name: "Computer Software Stores" },
	{ name: "Record Stores" },
	{ name: "Caterers" },
	{ name: "Eating Places and Restaurants" },
	{ name: "Fast Food Restaurants" },
	{ name: "Digital Goods Media-Books, Movies, Music" },
	{ name: "Digital Goods-Games" },
	{ name: "Digital Goods-Applications (Excludes Games)" },
	{ name: "Drug Stores and Pharmacies" },
	{ name: "Package Stores-Beer, Wine, and Liquor" },
	{ name: "Used Merchandise and Secondhand Stores" },
	{ name: "Antique Shops-Sales, Repairs, and Restoration Services" },
	{ name: "Wrecking and Salvage Yards" },
	{ name: "Bicycle Shops-Sales and Service" },
	{ name: "Sporting Goods Stores" },
	{ name: "Bookshops" },
	{ name: "Stationery Stores, Office and School Supply Stores" },
	{ name: "Hobby, Toy, and Game Shops" },
	{ name: "Camera and Photographic Supply Stores" },
	{ name: "Gift, Card, Novelty and Souvenir Shops" },
	{ name: "Luggage and Leather Goods Stores" },
	{ name: "Sewing, Needlework, Fabric and Piece Goods Stores" },
	{ name: "Glassware/Crystal Stores" },
	{ name: "Direct Marketing-Insurance Services" },
	{ name: "Direct Marketing-Inbound Teleservices Merchant" },
	{ name: "Direct Marketing-Other Direct Marketers" },
	{ name: "Artist's Supply and Craft Shops" },
	{ name: "Art Dealers and Galleries" },
	{ name: "Stamp and Coin Stores" },
	{ name: "Religious Goods Stores" },
	{ name: "Hearing Aids-Sales, Service, and Supply" },
	{ name: "Orthopaedic Goods-Prosthetic Devices" },
	{ name: "Cosmetic Stores" },
	{ name: "Typewriter Stores-Sales, Rentals, and Service" },
	{ name: "Florists" },
	{ name: "Cigar Stores and Stands" },
	{ name: "News Dealers and Newsstands" },
	{ name: "Pet Shops, Pet Foods and Supplies Stores" },
	{ name: "Swimming Pools-Sales and Service" },
	{ name: "Electric Razor Stores-Sales and Service" },
	{ name: "Tent and Awning Shops" },
	{ name: "Miscellaneous and Specialty Retail Shops" },
	{ name: "Financial Institutions-Merchandise and Services" },
	{ name: "Non-Financial Institutions-Foreign Currency, Money Orders (Not Wire Transfer), and Travellers Cheques" },
	{ name: "Security Brokers/Dealers" },
	{ name: "Insurance Sales, Underwriting, and Premiums" },
	{ name: "Real Estate Agents and Managers-Rentals" },
	{ name: "Lodging-Hotels, Motels, Resorts, Central Reservation Services" },
	{ name: "Timeshares" },
	{ name: "Sporting and Recreational Camps" },
	{ name: "Trailer Parks and Camping Grounds" },
	{ name: "Laundromat, Cleaning, and Garment Services" },
	{ name: "Laundries-Family and Commercial" },
	{ name: "Dry Cleaners" },
	{ name: "Carpet and Upholstery Cleaning" },
	{ name: "Photographic Studios" },
	{ name: "Beauty and Barber Shops" },
	{ name: "Shoe Repair Shops, Shoe Shine Parlours, and Hat Cleaning Shops" },
	{ name: "Dating Services" },
	{ name: "Counselling Services-Debt, Marriage, and Personal" },
	{ name: "Buying and Shopping Services and Clubs" },
	{ name: "Clothing Rental-Costumes, Uniforms, Formal Wear" },
	{ name: "Health and Beauty Spas" },
	{ name: "Miscellaneous Personal Services" },
	{ name: "Advertising Services" },
	{ name: "Consumer Credit Reporting Agencies" },
	{ name: "Commercial Photography, Art, and Graphics" },
	{ name: "Quick Copy, Reproduction, and Blueprinting Services" },
	{ name: "Stenographic and Secretarial Support" },
	{ name: "Exterminating and Disinfecting Services" },
	{ name: "Cleaning, Maintenance, and Janitorial Services" },
	{ name: "Employment Agencies and Temporary Help Services" },
	{ name: "Computer Programming, Data Processing, and Integrated Systems Design Services" },
	{ name: "Information Retrieval Services" },
	{ name: "Computer Maintenance, Repair and Services" },
	{ name: "Management, Consulting, and Public Relations Services" },
	{ name: "Detective Agencies, Protective Services, and Security Services, including Armored Cars, and Guard Dogs" },
	{ name: "Equipment, Tool, Furniture, and Appliance Rental and Leasing" },
	{ name: "Photofinishing Laboratories and Photo Developing" },
	{ name: "Business services" },
	{ name: "Car hire agency" },
	{ name: "Truck and Utility Trailer Rentals" },
	{ name: "Motor Home and Recreational Vehicle Rentals" },
	{ name: "Car Parks, Parking Meters and Garages" },
	{ name: "Automotive Body Repair Shops" },
	{ name: "Tyre Retreading and Repair Shops" },
	{ name: "Automotive Paint Shops" },
	{ name: "Automotive Service Shops (Non-Dealer)" },
	{ name: "Car Washes" },
	{ name: "Towing Services" },
	{ name: "Electronics Repair Shops" },
	{ name: "Air Conditioning and Refrigeration Repair Shops" },
	{ name: "Electrical and Small Appliance Repair Shops" },
	{ name: "Watch, Clock and Jewellery Repair" },
	{ name: "Furniture-Reupholstery, Repair, and Refinishing" },
	{ name: "Welding Services" },
	{ name: "Miscellaneous Repair Shops and Related Services" },
	{ name: "Motion Picture and Video Tape Production and Distribution" },
	{ name: "Motion Picture Theatres" },
	{ name: "Dance Halls, Studios and Schools" },
	{ name: "Theatrical Producers (Except Motion Pictures) and Ticket Agencies" },
	{ name: "Bands, Orchestras, and Miscellaneous Entertainers" },
	{ name: "Billiard and Pool Establishments" },
	{ name: "Bowling Alleys" },
	{ name: "Commercial Sports, Professional Sports Clubs, Athletic Fields, and Sports Promoters" },
	{ name: "Tourist Attractions and Exhibits" },
	{ name: "Public Golf Courses" },
	{ name: "Video Amusement Game Supplies" },
	{ name: "Video Game Arcades/Establishments" },
	{ name: "Betting, including Lottery Tickets, Casino Gaming Chips, Off-Track Betting, and Wagers at Race Tracks" },
	{ name: "Amusement parks, circuses, carnivals and fortune tellers" },
	{ name: "Membership Clubs (Sports, Recreation, Athletic), Country Clubs, and Private Golf Courses" },
	{ name: "Aquariums, Seaquariums, Dolphinariums, and Zoos" },
	{ name: "Recreation Services" },
	{ name: "Dentists and Orthodontists" },
	{ name: "Opticians, Optical Goods, and Eyeglasses" },
	{ name: "Medical Services and Health Practitioners" },
	{ name: "Legal Services and Lawyers" },
	{ name: "Elementary and Secondary Schools" },
	{ name: "Colleges, Universities, Professional Schools, and Junior Colleges" },
	{ name: "Correspondence Schools" },
	{ name: "Business and Secretarial Schools" },
	{ name: "Vocational and Trade Schools" },
	{ name: "Schools and Educational Services" },
	{ name: "Child Care Services" },
	{ name: "Charitable and Social Service Organisations" },
	{ name: "Civic, Social, and Fraternal Associations" },
	{ name: "Political Organisations" },
	{ name: "Religious Organisations" },
	{ name: "Car Associations" },
	{ name: "Membership Organisations" },
	{ name: "Architectural, Engineering, and Surveying Services" },
	{ name: "Accounting, Auditing, and Bookkeeping Services" },
	{ name: "Professional Services" },
	{ name: "Government Services" },
	{ name: "Veterinary Services" },
	{ name: "Agricultural Co-operatives" },
	{ name: "Landscaping and Horticultural Services" }
];
export const INCOME_12 = [
	{ name: "Too early to say" },
	{ name: "$0.00 - $20,000.00" },
	{ name: "$20,000.00 - $150,000.00" },
	{ name: "$150,000.00 - $500,000.00" },
	{ name: "$500,000.00 - $1,000,000.00" },
	{ name: "$1,000,000.00 & above" },

];
